import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import config from '../Config'

const app = initializeApp(config.FIREBASE)
const analytics = getAnalytics(app)

export default analytics
